import type { Interval } from '@/shared/lib'
import { addMinutes, atMinutes, isSameDay, minutesSinceMidnight } from '@/shared/lib'

const QUARTER_MIN = 15
const LENGTH_MIN = 60
/** Дню без «сейчас» нужен ориентир — утро рабочего окна, а не полночь. */
const MORNING_MIN = 10 * 60

/** Час от ближайшей четверти: на сегодня — от текущего времени, иначе с утра. */
export function defaultSlot(day: Date, now: Date = new Date()): Interval {
  const startMin = isSameDay(day, now)
    ? Math.ceil(minutesSinceMidnight(now) / QUARTER_MIN) * QUARTER_MIN
    : MORNING_MIN
  const startsAt = atMinutes(day, startMin)
  return { startsAt, endsAt: addMinutes(startsAt, LENGTH_MIN) }
}
